import * as React from 'react';
import { Link as ReactLink } from 'react-router';

interface ILinkProps {
	isHidden?: boolean;
	to?: string;
	href?: string;
	className?: string;
	onClick?: () => void;
}

export default class OGMLink extends React.PureComponent<ILinkProps> {
	public render() {
		const { isHidden, to, className, href, onClick, ...rest } = this.props;

		let linkEl = null;
		if (!isHidden) {
			if (href) {
				linkEl = (
					<a href={href} onClick={onClick} {...rest}>
						{this.props.children}
					</a>
				);
			} else {
				linkEl = (
					<ReactLink className={className} to={to} onClick={onClick} {...rest}>
						{this.props.children}
					</ReactLink>
				);
			}
		}

		return linkEl;
	}
}
